export default __webpack_public_path__ + "static/media/automatisch.jpg";